import { render, staticRenderFns } from "./PlayerChatUnblockAdd.vue?vue&type=template&id=d8910d00&"
import script from "./PlayerChatUnblockAdd.vue?vue&type=script&lang=js&"
export * from "./PlayerChatUnblockAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports